import React, { useState } from 'react';

import { PlusOutlined } from '@ant-design/icons';
import { Button as AntdButton } from 'antd';

import { FilterDashboardFourriere } from 'types/referentiels/Fourriere';

import ModalCreate from '../Modals/ModalCreate';

import Filter from './Filter/Filter';

import './DashboardHeader.less';

interface DashboardHeaderProps {
  totalCount: number;
  setFilter: (value: Partial<FilterDashboardFourriere>) => void;
  filter: Partial<FilterDashboardFourriere>;
}

function DashboardHeader({
  totalCount,
  filter,
  setFilter,
}: DashboardHeaderProps): React.ReactElement {
  const countString = `${totalCount} fourrière${
    totalCount > 1 ? 's' : ''
  } trouvée${totalCount > 1 ? 's' : ''}`;

  const [modalCreationOpen, setModalCreationOpen] = useState<boolean>(false);

  const openModal = () => {
    setModalCreationOpen(true);
  };

  const closeModal = () => {
    setModalCreationOpen(false);
  };

  const refreshDashboard = () => {
    setFilter({ ...filter });
  };

  return (
    <div>
      <div className="dashboard-header-fields header-referentiels">
        <Filter filter={filter} setFilter={setFilter} />
        <AntdButton
          icon={<PlusOutlined />}
          type={'primary'}
          shape={'round'}
          onClick={openModal}
        >
          Créer une fourrière
        </AntdButton>
        <ModalCreate
          visible={modalCreationOpen}
          close={closeModal}
          refreshDashboard={refreshDashboard}
        />
      </div>
      <p className="dashboard-number-fourrieres">{countString}</p>
    </div>
  );
}

export default DashboardHeader;
